// extracted by mini-css-extract-plugin
module.exports = {"titles":"HeroBannerPromoGeneral_titles__2e9vs","titlesWrapper":"HeroBannerPromoGeneral_titlesWrapper__quzh0"};